import {useFormik} from "formik";
import ModalMsg from "../../../components/ModalMsg";
import React, {useContext, useState} from "react";
import {LoaderContext} from "../../../context/LoaderContext";
import {Link} from "react-router-dom";
import {inviaEmailRecuperaPasswordApi} from "../../../services/UtentiServices";

function RecuperaPwd() {

    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);

    const {startChiamata, endChiamata} = useContext(LoaderContext);

    const closeModal = () => setShow(false);

    async function inviaEmailRecuperaPassword(values) {
        startChiamata();
        const response = await inviaEmailRecuperaPasswordApi(values);
        setModalMsg(response.data.description);
        setShow(true);
        endChiamata();
    }

    const formik = useFormik({
        initialValues: {
            mail: ''
        }, onSubmit: async values => {
            await inviaEmailRecuperaPassword(values);
        }
    });

    return (
        <div>
            <ModalMsg
                show={show}
                handleClose={closeModal}
                testo={modalMsg}/>
            <div className={"text-center mt-4 mb-4 rfi-titolo"}>
                <h1>Recupera la tua password</h1>
                <h5>Inserisci il tuo indirizzo E-mail</h5>
            </div>
            <div className="rfi-login rfi-recupera-pwd mt-4">
                <div>
                    <form className="row g-3 needs-validation"
                          method="post"
                          noValidate=""
                          onSubmit={formik.handleSubmit}>
                        <div className="col-12">
                            <label htmlFor="mail" className="form-label">Indirizzo E-mail:</label>
                            <input
                                id="mail"
                                name="mail"
                                type="text"
                                onChange={formik.handleChange}
                                value={formik.values.mail}
                                className="form-control"
                                required/>
                            <div className="invalid-feedback">
                                L'indirizzo E-Mail deve essere valorizzato.
                            </div>
                        </div>
                        <div className="d-grid gap-2">
                            <button type="submit" name="conferma" id="conferma" className="btn btn-dark">
                                <i className="fas fa-user-lock"/> Conferma
                            </button>
                            <Link to="/" className="btn btn-dark">
                                <i className="fas fa-chevron-left"/> Indietro
                            </Link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default RecuperaPwd;
